import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

// Readable line-width cap for the header description copy.
const HEADER_COPY_MAX_WIDTH = 800;
// Keeps the expiration date column from collapsing so it stays aligned against the status pill.
const EXPIRATION_DATE_MIN_WIDTH = 90;

export const styleSheet = StyleSheet.create({
	card: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		marginBottom: THEME.spacing.lg,
		marginTop: THEME.spacing.lg,
		overflow: 'hidden',
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	header: {
		alignItems: 'flex-start',
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: THEME.spacing.xl,
	},
	headerCopy: {
		maxWidth: HEADER_COPY_MAX_WIDTH,
	},
	headerActions: {
		flexShrink: 0,
		padding: THEME.spacing.md,
	},
	keyCell: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	scopeCell: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	expirationCell: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	expirationDate: {
		minWidth: EXPIRATION_DATE_MIN_WIDTH,
	},
	dialogForm: {
		gap: THEME.spacing.md,
	},
	docsFooter: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
		justifyContent: 'center',
		marginTop: THEME.spacing.lg,
		padding: THEME.spacing.lg,
	},
});
